import Actions from 'actions';

const initialState = Object.freeze({});

function validateResetPasswordCode(state = initialState, action) {
  switch (action.type) {
    case Actions.VALIDATE_RESET_PASSWORD_CODE_REQUEST:
      return initialState;
    case Actions.VALIDATE_RESET_PASSWORD_CODE_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.VALIDATE_RESET_PASSWORD_CODE_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default validateResetPasswordCode;
